// Beneficiary Report
export var EExportActionType;
(function (EExportActionType) {
    EExportActionType["Create"] = "CREATE";
    EExportActionType["CreateAndEmail"] = "CREATE_AND_EMAIL";
})(EExportActionType || (EExportActionType = {}));
// Revenues
export var ERevenuesPaymentStatus;
(function (ERevenuesPaymentStatus) {
    ERevenuesPaymentStatus["Unpaid"] = "UNPAID";
    ERevenuesPaymentStatus["Pending"] = "PENDING_AT_RENTIO";
    ERevenuesPaymentStatus["Paid"] = "PAID";
})(ERevenuesPaymentStatus || (ERevenuesPaymentStatus = {}));
export var ERevenuesInvoicedStatus;
(function (ERevenuesInvoicedStatus) {
    ERevenuesInvoicedStatus["Invoiced"] = "INVOICED";
    ERevenuesInvoicedStatus["NotInvoiced"] = "NOT_INVOICED";
})(ERevenuesInvoicedStatus || (ERevenuesInvoicedStatus = {}));
// Entity
export var EExportFileType;
(function (EExportFileType) {
    EExportFileType["Csv"] = "CSV";
    EExportFileType["Pdf"] = "PDF";
})(EExportFileType || (EExportFileType = {}));
export var EExportType;
(function (EExportType) {
    EExportType["Activity"] = "ACTIVITY";
    EExportType["BeneficiaryReport"] = "BENEFICIARY_REPORT";
    EExportType["Contact"] = "CONTACT";
    EExportType["Revenues"] = "REVENUES";
})(EExportType || (EExportType = {}));
export var EExportStatus;
(function (EExportStatus) {
    EExportStatus["New"] = "NEW";
    EExportStatus["Generated"] = "GENERATED";
    EExportStatus["Failed"] = "FAILED";
})(EExportStatus || (EExportStatus = {}));
